import { Scene } from "phaser";
import BootScene from "./BootScene";
import Game from "./Game";
import FramesCollector from "./FramesCollector";
import ImagePanner from "./ImagePanner";
import SwipeRotation from "./SwipeRotation";
import Pqp from "../../3x1010/Pqp";
import KeyboardControls from "./KeyboardControls";

export default class MainScene extends Scene {
  constructor() {
    super("MainScene");
    this.spans = [];
    for (let x = 0; x < Game.spans.length; x++) {
      this.spans.push({ span: Game.spans[x], clip: null });
    }
    this.currentSpan = Game.spans[0];
    this.currentFrame = 0;
    this.currentZoom = 1;
    this.holdTimeout = null;
    this.repeatInterval = null;
    this.initialDelay = 300;
    this.repeatDelay = Game.autoPlayInterval;
    this.autoPlayInterval = null;
    this.ct = Game.targetContext;
  }

  preload() {}

  create() {
    this.ct.querySelector(".loader-spinner").remove();

    // Crea lo span più piccolo
    this.createSpan(Game.spans[0]);
    // Inizializza il reset sul resize
    this.initResize();

    // Inizializza il mousewheel
    this.initMouseWheel();

    // Inizializza i controlli
    this.initControls();

    // Resetta tutto
    this.reset();

    // Fa apparire il canvas
    this.showCanvas();
  }

  showCanvas() {
    const o = {
      value: 0,
    };

    this.tweens.add({
      targets: o,
      value: 100,
      duration: 500,
      onUpdate: () => {
        this.ct.querySelector("canvas").style.opacity = o.value / 100;
      },
    });
  }

  createSpan(span) {
    // Controlla se per l'ha già creato
    for (let x = 0; x < this.spans.length; x++) {
      if (this.spans[x].span === span) {
        if (this.spans[x].clip) {
          return this.spans[x].clip;
        }
      }
    }
    // console.log("Creating span:", span);
    // Crea lo span
    const clip = new FramesCollector(this, span);
    clip.init(this.currentFrame);
    this.add.existing(clip);
    for (let x = 0; x < this.spans.length; x++) {
      if (this.spans[x].span === span) {
        this.spans[x].clip = clip;
        break;
      }
    }

    // Riorganizza i clip come z-index
    for (let x = 0; x < this.spans.length; x++) {
      if (this.spans[x].clip) {
        this.children.bringToTop(this.spans[x].clip);
      }
    }

    return clip;
  }

  initResize() {
    this.scale.on("resize", this.onResize.bind(this));
  }

  onResize(gameSize, baseSize, displaySize, resolution) {
    if (this.idto) {
      this.idto.remove();
    }
    this.idto = this.time.delayedCall(100, () => {
      this.reset();
    });
  }

  reset() {
    // resetta lo zoom
    this.currentZoom = 1;

    // Visualizza (ed eventualmente crea) lo span corrente
    const currentSpan = BootScene.getCurrentSpan(this);
    for (let x = 0; x < this.spans.length; x++) {
      if (x > 0) {
        // Il primo lo lascia sempre visibile come fallback
        if (this.spans[x].span !== currentSpan) {
          if (this.spans[x].clip) {
            this.spans[x].clip.visible = false;
          }
        } else {
          if (this.spans[x].clip) {
            this.spans[x].clip.visible = true;
            //console.log("Showing span:", this.spans[x].span);
          } else {
            this.createSpan(currentSpan);
          }
        }
      }
      // A tutti i clip setta comunque l'immagine corrente e resetta le dimensioni
      if (this.spans[x].clip) {
        this.spans[x].clip.setFrame(this.currentFrame);
        this.spans[x].clip.setDefaultSize();
      }
    }
    this.currentSpan = currentSpan;
    //console.log("Current span:", currentSpan);
  }

  initMouseWheel() {
    this.input.on("wheel", (pointer, gameObjects, deltaX, deltaY, deltaZ) => {
      if (deltaY > 0) {
        this.zoomOut();
      } else if (deltaY < 0) {
        this.zoomIn();
      }
    });
  }

  getSpan(span) {
    for (let x = 0; x < this.spans.length; x++) {
      if (this.spans[x].span === span) {
        return this.spans[x].clip;
      }
    }
    return null;
  }

  getNextSpan(span) {
    for (let x = 0; x < this.spans.length; x++) {
      if (this.spans[x].span === span) {
        if (x + 1 < this.spans.length) {
          return this.spans[x + 1].span;
        }
      }
    }
    return null;
  }

  getPrevSpan(span) {
    for (let x = 0; x < this.spans.length; x++) {
      if (this.spans[x].span === span) {
        if (x - 1 >= 0) {
          return this.spans[x - 1].span;
        }
      }
    }
    return null;
  }

  zoomIn() {
    this.stopAutoPlay();
    if (this.currentSpan === Game.spans[Game.spans.length - 1]) {
      //console.log(this.currentZoom);
      if (this.currentZoom >= Game.finalMaxZoom) {
        return;
      }
    }

    this.currentZoom += this.getZoomStep(this.currentSpan);
    //console.log("Zoom in " + this.currentZoom);
    // Prende il current span
    const span = this.getSpan(this.currentSpan);
    // Lo zoooma
    span.zoomIn(this.currentZoom);
    // Lo applica anche a quello sempre visibile
    const span0 = this.getSpan(Game.spans[0]);
    span0.zoomIn(this.currentZoom);
    //console.log(span.scale);
    // Calcola le nuove dimensioni reali
    const newDim = this.calculateNewDimensions(this.calculateOriginalWidth(this.currentSpan), this.currentSpan, span.scale);

    // Calcola le dimensioni visibili del canvas
    const visCanvasDim = this.getCurrentCanvasVisibleDimensions();
    //console.log(visCanvasDim);
    // Calcola le dimensioni visibili dello span corrente
    const visDim = this.calculateVisibleDimensions(newDim, Game.WIDTH, Game.HEIGHT, visCanvasDim.width, visCanvasDim.height);

    // Se le dimensioni visibili dello span corrente sono maggiori di quelle attuali
    if (visDim.height > this.currentSpan) {
      // Prende lo span successivo (se esiste e lo crea se non esiste)
      const nextSpan = this.getNextSpan(this.currentSpan);
      if (!nextSpan) {
        return;
      }

      let nextSpanClip = this.getSpan(nextSpan);
      if (nextSpanClip) {
        nextSpanClip.visible = true;
        nextSpanClip.setDefaultSize();
      } else {
        nextSpanClip = this.createSpan(nextSpan);
      }
      /*if (this.currentSpan !== Game.spans[0]) {
        this.getSpan(this.currentSpan).visible = false;
      }*/
      nextSpanClip.visible = true;

      this.currentSpan = nextSpan;
      // Calcola il fattore di scala per adattare il nuovo span alle dimensioni che aveva quello vecchio
      const scaleFactor = this.calculateScaleToMatch(newDim, this.calculateOriginalWidth(nextSpan), nextSpan);
      nextSpanClip.setScale(scaleFactor);

      // Setta le stesse coordinate dello span corrente
      nextSpanClip.x = span.x;
      nextSpanClip.y = span.y;

      // Ottimizzazione, da tenere sotto controllo
      nextSpanClip.setFrame(this.currentFrame);

      // Lo applica anche a quello sempre visibile
      const scaleFactor0 = this.calculateScaleToMatch(newDim, this.calculateOriginalWidth(Game.spans[0]), Game.spans[0]);
      this.getSpan(Game.spans[0]).setScale(scaleFactor0);
      // Rende invisibili gli span precedenti (tranne quello sempre visibile)
      for (let x = 0; x < this.spans.length; x++) {
        if (this.spans[x].span !== Game.spans[0] && this.spans[x].span !== nextSpan) {
          if (this.spans[x].clip) {
            this.spans[x].clip.visible = false;
          }
        }
      }
    }
  }

  zoomOut() {
    this.stopAutoPlay();
    if (this.currentSpan === Game.spans[0]) {
      return;
    }

    this.currentZoom -= this.getZoomStep(this.currentSpan);
    //console.log("Zoom out " + this.currentZoom);
    // Prende il current span
    const span = this.getSpan(this.currentSpan);
    // Lo zoooma
    span.zoomOut(this.currentZoom);
    // Lo applica anche a quello sempre visibile
    const span0 = this.getSpan(Game.spans[0]);
    span0.zoomOut(this.currentZoom);

    // Calcola le nuove dimensioni reali
    const newDim = this.calculateNewDimensions(this.calculateOriginalWidth(this.currentSpan), this.currentSpan, span.scale);
    //console.log(newDim);
    // Calcola le dimensioni visibili del canvas
    const visCanvasDim = this.getCurrentCanvasVisibleDimensions();
    //console.log(visCanvasDim);
    // Calcola le dimensioni visibili dello span corrente
    const visDim = this.calculateVisibleDimensions(newDim, Game.WIDTH, Game.HEIGHT, visCanvasDim.width, visCanvasDim.height);
    //console.log(visDim);

    // Se le dimensioni visibili dello span corrente sono minori di quelle attuali
    if (visDim.height < this.currentSpan) {
      // Prende lo span precedente (se esiste e lo crea se non esiste)
      const prevSpan = this.getPrevSpan(this.currentSpan);
      if (!prevSpan) {
        return;
      }

      let prevSpanClip = this.getSpan(prevSpan);
      if (prevSpanClip) {
        prevSpanClip.visible = true;
        prevSpanClip.setDefaultSize();
      } else {
        prevSpanClip = this.createSpan(prevSpan);
      }
      if (this.currentSpan !== Game.spans[0]) {
        this.getSpan(this.currentSpan).visible = false;
      }
      prevSpanClip.visible = true;

      this.currentSpan = prevSpan;
      // Calcola il fattore di scala per adattare il nuovo span alle dimensioni che aveva quello vecchio
      const scaleFactor = this.calculateScaleToMatch(newDim, this.calculateOriginalWidth(prevSpan), prevSpan);
      prevSpanClip.setScale(scaleFactor);

      // Setta le stesse coordinate dello span corrente
      prevSpanClip.x = span.x;
      prevSpanClip.y = span.y;

      // Ottimizzazione, da tenere sotto controllo
      prevSpanClip.setFrame(this.currentFrame);

      // Lo applica anche a quello sempre visibile
      const scaleFactor0 = this.calculateScaleToMatch(newDim, this.calculateOriginalWidth(Game.spans[0]), Game.spans[0]);
      this.getSpan(Game.spans[0]).setScale(scaleFactor0);
      // Rende invisibili gli span precedenti (tranne quello sempre visibile)
      for (let x = 0; x < this.spans.length; x++) {
        if (this.spans[x].span !== Game.spans[0] && this.spans[x].span !== prevSpan) {
          if (this.spans[x].clip) {
            this.spans[x].clip.visible = false;
          }
        }
      }
    }
  }

  getCurrentCanvasVisibleDimensions() {
    const bounds = this.scale.canvasBounds;
    const canvasWidth = bounds.width;
    const canvasHeight = bounds.height;
    return { width: canvasWidth, height: canvasHeight };
  }

  calculateOriginalWidth(height) {
    // Calcola il rapporto d'aspetto del canvas
    const aspectRatio = Game.WIDTH / Game.HEIGHT;
    // Calcola la larghezza originale basata sull'altezza nota e il rapporto d'aspetto
    const originalWidth = aspectRatio * height;
    return originalWidth;
  }

  calculateNewDimensions(originalWidth, originalHeight, scaleFactor) {
    // Calcola le nuove dimensioni dopo l'applicazione dello scaleFactor
    const newWidth = originalWidth * scaleFactor;
    const newHeight = originalHeight * scaleFactor;
    return {
      width: newWidth,
      height: newHeight,
    };
  }

  calculateVisibleDimensions(newDimensions, canvasOriginalWidth, canvasOriginalHeight, canvasResizedWidth, canvasResizedHeight) {
    // Calcola il fattore di ridimensionamento basato sull'altezza del canvas
    const scaleFactor = canvasResizedHeight / canvasOriginalHeight;
    // Calcola le dimensioni visibili tenendo conto del ridimensionamento del canvas
    const visibleWidth = newDimensions.width * scaleFactor;
    const visibleHeight = newDimensions.height * scaleFactor;

    return {
      width: visibleWidth,
      height: visibleHeight,
    };
  }

  calculateScaleToMatch(newDimensions, originalWidth, originalHeight) {
    const scaleX = newDimensions.width / originalWidth;
    const scaleY = newDimensions.height / originalHeight;
    return Math.min(scaleX, scaleY);
  }

  getZoomStep(span) {
    //console.log(span);
    for (let x = 0; x < Game.spans.length; x++) {
      if (Game.spans[x] === span) {
        return Game.zoomSteps[x];
      }
    }
    return 0.1;
  }

  setFrame(frame) {
    this.currentFrame = frame;
    for (let x = 0; x < this.spans.length; x++) {
      if (this.spans[x].clip) {
        this.spans[x].clip.setFrame(this.currentFrame);
      }
    }
  }

  nextFrame() {
    this.currentFrame++;
    if (this.currentFrame >= Game.frames) {
      this.currentFrame = 0;
    }
    for (let x = 0; x < this.spans.length; x++) {
      if (this.spans[x].clip) {
        this.spans[x].clip.setFrame(this.currentFrame);
      }
    }
  }

  prevFrame() {
    this.currentFrame--;
    if (this.currentFrame < 0) {
      this.currentFrame = Game.frames - 1;
    }
    for (let x = 0; x < this.spans.length; x++) {
      if (this.spans[x].clip) {
        this.spans[x].clip.setFrame(this.currentFrame);
      }
    }
  }

  initControls() {
    // Riferimenti ai pulsanti
    const rotateLeftButton = this.ct.querySelector(".js-ctrl-rotate-left");
    const rotateRightButton = this.ct.querySelector(".js-ctrl-rotate-right");
    const zoomInButton = this.ct.querySelector(".js-ctrl-zoom-in");
    const zoomOutButton = this.ct.querySelector(".js-ctrl-zoom-out");
    const toggleFullscreen = this.ct.querySelector(".js-fullscreen");
    const autoPlay = this.ct.querySelector(".js-ctrl-autoplay");
    const panOrSwipe = this.ct.querySelector(".js-drag");

    // Ruota a sinistra e destra
    rotateLeftButton.addEventListener("mousedown", this.startRotateLeft.bind(this));
    rotateLeftButton.addEventListener("touchstart", this.startRotateLeft.bind(this));
    rotateLeftButton.addEventListener("mouseup", this.stopRotation.bind(this));
    rotateLeftButton.addEventListener("mouseleave", this.stopRotation.bind(this));
    rotateLeftButton.addEventListener("touchend", this.stopRotation.bind(this));

    rotateRightButton.addEventListener("mousedown", this.startRotateRight.bind(this));
    rotateRightButton.addEventListener("touchstart", this.startRotateRight.bind(this));
    rotateRightButton.addEventListener("mouseup", this.stopRotation.bind(this));
    rotateRightButton.addEventListener("mouseleave", this.stopRotation.bind(this));
    rotateRightButton.addEventListener("touchend", this.stopRotation.bind(this));

    // Zoom in e out
    zoomInButton.addEventListener("mousedown", this.startZoomIn.bind(this));
    zoomInButton.addEventListener("touchstart", this.startZoomIn.bind(this));
    zoomInButton.addEventListener("mouseup", this.stopZoom.bind(this));
    zoomInButton.addEventListener("mouseleave", this.stopZoom.bind(this));
    zoomInButton.addEventListener("touchend", this.stopZoom.bind(this));

    zoomOutButton.addEventListener("mousedown", this.startZoomOut.bind(this));
    zoomOutButton.addEventListener("touchstart", this.startZoomOut.bind(this));
    zoomOutButton.addEventListener("mouseup", this.stopZoom.bind(this));
    zoomOutButton.addEventListener("mouseleave", this.stopZoom.bind(this));
    zoomOutButton.addEventListener("touchend", this.stopZoom.bind(this));

    // Panning
    this.panner = new ImagePanner(this.spans, this);
    this.swiper = new SwipeRotation(this);
    // All'inizio è attivo lo swipe
    this.panner.disable();
    this.swiper.enable();
    this.ct.querySelector("canvas").classList.remove("js-is-pan");
    this.ct.querySelector("canvas").classList.add("js-is-rotate360");

    // Panning o swipe
    panOrSwipe.addEventListener("click", () => {
      this.stopAutoPlay();
      if (this.panner.enabled) {
        this.ct.querySelector(".js-icon-pan").classList.remove("hidden");
        this.ct.querySelector(".js-icon-rotate360").classList.add("hidden");
        this.ct.querySelector("canvas").classList.remove("js-is-pan");
        this.ct.querySelector("canvas").classList.add("js-is-rotate360");
        this.panner.disable();
        this.swiper.enable();
      } else {
        this.ct.querySelector(".js-icon-pan").classList.add("hidden");
        this.ct.querySelector(".js-icon-rotate360").classList.remove("hidden");

        this.ct.querySelector("canvas").classList.add("js-is-pan");
        this.ct.querySelector("canvas").classList.remove("js-is-rotate360");

        this.panner.enable();
        this.swiper.disable();
      }
    });

    // Fullscreen toggle
    toggleFullscreen.addEventListener("click", () => {
      if (document.fullscreenElement) {
        this.exitFullscreen();
      } else {
        this.enterFullscreen();
      }
    });
    document.addEventListener("fullscreenchange", this.updateFullscreenIcon.bind(this)); // Per standard
    document.addEventListener("webkitfullscreenchange", this.updateFullscreenIcon.bind(this)); // Per Safari e Chrome
    document.addEventListener("mozfullscreenchange", this.updateFullscreenIcon.bind(this)); // Per Firefox
    document.addEventListener("MSFullscreenChange", this.updateFullscreenIcon.bind(this)); // Per IE/Edge

    // Autoplay
    autoPlay.addEventListener("click", () => {
      this.autoPlay();
    });

    // Reset
    this.ct.querySelector(".js-ctrl-reset").addEventListener("click", () => {
      this.reset();
    });

    // Pinch
    const pinch = this.rexGestures.add.pinch();
    pinch.on("pinch", this.onPinch.bind(this));
    //this.txt = this.add.text(0, 0, "Pinch me", { fontSize: "40px", color: "#000000" });

    // Rimuove il menu contestuale
    document.querySelectorAll("img").forEach((img) => {
      img.addEventListener("contextmenu", (event) => event.preventDefault());
    });

    // Controllo tastiera
    const keyboardControls = new KeyboardControls(this, this.handleKeyboardEvents.bind(this));
  }

  /*update() {
    this.children.bringToTop(this.txt);
  }*/

  onPinch(pinch) {
    const { scaleFactor } = pinch;
    //this.txt.setText(Pqp.rnd(10000) + " " + scaleFactor);
    if (scaleFactor > 1) {
      this.zoomIn();
    } else if (scaleFactor < 1) {
      this.zoomOut();
    }
  }

  startRotateLeft() {
    this.stopAutoPlay();
    this.prevFrame();
    this.holdTimeout = setTimeout(() => {
      this.repeatInterval = setInterval(this.prevFrame.bind(this), this.repeatDelay); // Ripete dopo il delay
    }, this.initialDelay);
  }

  startRotateRight() {
    this.stopAutoPlay();
    this.nextFrame();
    this.holdTimeout = setTimeout(() => {
      this.repeatInterval = setInterval(this.nextFrame.bind(this), this.repeatDelay); // Ripete dopo il delay
    }, this.initialDelay);
  }

  stopRotation() {
    // Pulisce
    clearTimeout(this.holdTimeout);
    clearInterval(this.repeatInterval);
  }

  startZoomIn() {
    this.zoomIn();
    this.holdTimeout = setTimeout(() => {
      this.repeatInterval = setInterval(this.zoomIn.bind(this), this.repeatDelay); // Ripete dopo il delay
    }, this.initialDelay);
  }

  startZoomOut() {
    this.zoomOut();
    this.holdTimeout = setTimeout(() => {
      this.repeatInterval = setInterval(this.zoomOut.bind(this), this.repeatDelay); // Ripete dopo il delay
    }, this.initialDelay);
  }

  stopZoom() {
    // Pulisce
    clearTimeout(this.holdTimeout);
    clearInterval(this.repeatInterval);
  }

  // Funzione per entrare in modalità fullscreen
  enterFullscreen() {
    this.stopAutoPlay();
    const element = document.getElementById("mnc-player");

    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      // Firefox
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      // IE/Edge
      element.msRequestFullscreen();
    }
  }

  // Funzione per uscire dal fullscreen (opzionale)
  exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      // Chrome, Safari and Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // IE/Edge
      document.msExitFullscreen();
    }
  }

  updateFullscreenIcon() {
    if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
      // Siamo in fullscreen
      this.ct.querySelector(".js-icon-fullscreen").classList.add("hidden");
      this.ct.querySelector(".js-icon-window").classList.remove("hidden");
    } else {
      // Non siamo in fullscreen
      this.ct.querySelector(".js-icon-fullscreen").classList.remove("hidden");
      this.ct.querySelector(".js-icon-window").classList.add("hidden");
    }
  }

  autoPlay() {
    if (this.autoPlayInterval) {
      this.stopAutoPlay();
    } else {
      this.autoPlayInterval = setInterval(this.nextFrame.bind(this), Game.autoPlayInterval);
      this.ct.querySelector(".js-icon-autoplay-on").classList.add("hidden");
      this.ct.querySelector(".js-icon-autoplay-off").classList.remove("hidden");
    }
  }

  stopAutoPlay() {
    this.ct.querySelector(".js-icon-autoplay-on").classList.remove("hidden");
    this.ct.querySelector(".js-icon-autoplay-off").classList.add("hidden");

    clearInterval(this.autoPlayInterval);
    this.autoPlayInterval = null;
  }

  handleKeyboardEvents(type, value) {
    if (type === "zoom") {
      if (value === 1) {
        this.zoomIn();
      } else {
        this.zoomOut();
      }
    }
    if (type === "panOrRotate") {
      if (this.panner.enabled) {
        // poi vediamo per ora fa il rotate comunque
        if (value === 1) {
          this.nextFrame();
        } else {
          this.prevFrame();
        }
      } else {
        if (value === 1) {
          this.nextFrame();
        } else {
          this.prevFrame();
        }
      }
    }
  }
}

MainScene.ZOOM_STEP = 0.1;

